//没有头部和尾部的页面
const router = [
  {
    path: "/login",
    meta: {
      title: "login",
    },
    component: (resolve) => require(["../views/login/login"], resolve),
  },
  {
    path: "/officeScreen",
    meta: {
      title: "办公室大屏",
      // keepAlive: true
    },
    component: (resolve) => require(["../views/screen/officeScreen"], resolve),
  },
  {
    path: "/xiamenScreen",
    meta: {
      title: "办公室大屏",
      // keepAlive: true
    },
    component: (resolve) => require(["../views/screen/xiamenScreen"], resolve),
  },
];

export default router;



// WEBPACK FOOTER //
// ./src/router/indexEmpty.js